import { AuthConsumer } from 'providers/authProvider'
import LoadingScreen from '../../components/loading-screen'

export const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout()
            return <LoadingScreen />
        }}
    </AuthConsumer>
)
